"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressFormSchema = void 0;
const Yup = require("yup");
exports.addressFormSchema = Yup.object({
    firstName: Yup.string()
        .required('First name is a required field')
        .max(30, 'Max 30 characters')
        .matches(/^[a-zA-Z\s\-]+$/, 'Only alphabets are allowed for this field'),
    lastName: Yup.string()
        .required('Last name is a required field')
        .max(30, 'Max 30 characters')
        .matches(/^[a-zA-Z\s\-]+$/, 'Only alphabets are allowed for this field'),
    company: Yup.string().optional().max(30, 'Max 30 characters'),
    streetAddress: Yup.string()
        .required('Street address is a required field')
        .max(60, 'Max 60 characters')
        .matches(/^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i, 'Invalid Address: FedEx Does Not Deliver to P.O. Boxes'),
    apartment: Yup.string().optional().max(60, 'Max 60 characters'),
    city: Yup.string()
        .required('City is a required field')
        .max(30, 'Max 30 characters'),
    state: Yup.string()
        .required('State is a required field')
        .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field')
        .max(60, 'Max 30 characters'),
    zipCode: Yup.string()
        .required('Zip Code is a required field')
        .min(5, 'Invalid zip code')
        .max(10, 'Invalid zip code')
        .matches(/^(?:\d{5}(?:[-\s]\d{4})?|\d{9})$/, 'Invalid zip code'),
});
